<p fxLayout="row" fxLayoutAlign="flex-start top" class="sen-header-info sen-fs11 text-white font-weight-bold">
    <span *ngIf="selectedProject$ | async as project" title="{{project.name}}">{{translate.getLng('PROJECT_NAME')}} :
        {{project.name | truncate : 15}} <span *ngIf="project.totalKW">({{(convertToLocalNumber(project.totalKW.toFixed(2)))}}
            {{translate.getLng('UNIT_KWP')}})</span></span>
    <ng-container *ngIf="selectedPlan$ | async as plan">
        <mat-divider [vertical]="true" class="border-white mx-2"></mat-divider>
        <span title="{{plan.name}}">{{translate.getLng('ROOF_PLAN')}} :
            {{plan.name | truncate : 15}} <mat-icon matTooltipClass="sen-snackbar-color"
                matTooltip="{{translate.getLng('INVALID_PLAN_MESSAGE')}}" class="sen-fs16 sen-valign-sub"
                *ngIf="plan.invalid" color="invalid">
                warning</mat-icon> <span *ngIf="selectedPanelCount > -1">({{selectedPanelCount}}
                {{translate.getLng('MODULES')}}, {{convertToLocalNumber(planCapacity)}}
                {{translate.getLng('UNIT_KWP')}})</span></span>
    </ng-container>
    <ng-container *ngIf="selectedInverter$ | async as inverter">
        <mat-divider [vertical]="true" class="border-white mx-2"></mat-divider>
        <span>{{translate.getLng('INVERTER')}}</span> &nbsp;
        <mat-icon matTooltipClass="sen-snackbar-color"
            matTooltip="{{translate.getLng('INVALID_INVERTER_PLAN_MESSAGE')}}" class="sen-fs16 sen-valign-sub"
            *ngIf="inverter.invalid" color="invalid">
            warning</mat-icon>
    </ng-container>
</p>
